module.exports = __webpack_public_path__ + "static/media/page3.d3d1d9a2.png";